import axios from './index';

class ActiveStoresApi {
  static List = (data) => {
    let query = '?';
    if (data.orderType) {
      query += `order_type=${data.orderType}&`;
    }
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.orderId) {
      query = `${data.orderId}`;
    }
    if (data.customerId) {
      query = `user_id=${data.customerId}`;
    }
    if (data.category) {
      query += `category=${data.category}&`;
    }
    if (data.selectedStatusTypeValue) {
      query += `status_type=${data.selectedStatusTypeValue}&`;
    }
    if (data.selectedOrderTypeValue) {
      query += `order_type=${data.selectedOrderTypeValue}&`;
    }
    if (data.filterStartDate) {
      query += `start_date=${data.filterStartDate}&`;
    }
    if (data.filterEndDate) {
      query += `end_date=${data.filterEndDate}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };
  static CreateOrder = (data) => {
    let request = {
      csp_id: data.enrollmentId,
      user_id: data.customerId,
    };
    return axios.post(`${orderCreationbase}/`, request);
  };

  static Enroll = (data) => {
    let request = {
      saving_plan_store_id: data.storeId,
      user_id: data.customerId,
      monthly_amount: data.monthlyAmount,
    };
    return axios.post(`${enrollmentbase}/`, request);
  };

  static Update = (data) => {
    console.log('Data in updation', data);
    let request = {};
    request.aadhar = data.nomineeAadhaar;
    request.name = data.nomineeName;
    request.relation = data.nomineeRelation;
    request.dob = data.nomineeDob;
    request.phone_number = String(data.nomineeContact);
    request.referral_code = data.referralCode;

    return axios.put(`${enrollmentbase}/${data.enrollmentId}`, request);
  };

  static getById = (id) => {
    return axios.get(`${orderCreationbase}/${id}`);
  };
}

let base = 'customer/product/savingplanstore';
let enrollmentbase = 'customer/admin/order/enrollmentsavingplan';
let orderCreationbase = 'customer/admin/order/create-savingplan-order';

export default ActiveStoresApi;
